import 'globals';

(function (window, document, $) {
    var toggleIcons = document.querySelectorAll('.toggle-icon');
    for (var i = 0; i < toggleIcons.length; i++) {
        toggleIcons[i].addEventListener('click', function () {
            var element = $(this);
            var navItem = element.closest(".nav-item");

            var dropdownActive = Array.prototype.filter.call(navItem[0].children, function (child) {
                return child !== element && child.classList.contains('dropdown-menu');
            });

            if (navItem[0].classList.contains("opened")) {
                navItem[0].classList.remove('opened');
                dropdownActive[0].classList.remove('d-block');
                dropdownActive[0].classList.add('d-none');
            } else {
                navItem[0].classList.add('opened');
                dropdownActive[0].classList.remove('d-none');
                dropdownActive[0].classList.add('d-block');
            }
        });
    }

    $('.navbar-collapse').on('shown.bs.collapse', function () {
        var windowHeight = $(window).height(),
            metaMenuHeight = $('.navbar-metaMenu').height(),
            navbarHeaderHeight = $('.navbar-header').height(),
            navbarHeight = 100 - (100 / windowHeight * metaMenuHeight) - (100 / windowHeight * navbarHeaderHeight);

        $('.navbar-nav').css('height', navbarHeight + 'vh');
    });

    var metaMenu = $('.metaMenu'),
        metaMenuItems = metaMenu.find('.nav-link'),
        footerMenu = $('.footerMenu'),
        footerMenuItems = footerMenu.find('.nav-link');

    for (var j = 0; j < metaMenuItems.length; j++) {
        if(window.location.pathname == metaMenuItems[j].getAttribute('href'))
            metaMenuItems[j].classList.add('opened-item');
    }

    for (var j = 0; j < footerMenuItems.length; j++) {
        if(window.location.pathname == footerMenuItems[j].getAttribute('href'))
            footerMenuItems[j].classList.add('opened-item');
    }

    function deviceSupportsTouch() {
        try {
            document.createEvent("TouchEvent");
            return true;
        } catch (e) {
            return false;
        }
    }

    var isTouchDevice = deviceSupportsTouch();

    if(isTouchDevice) {
        $('.nav-item.first-level').find('.nav-overlay').addClass('d-none');
    } else {
        $('.nav-item.first-level').find('.nav-overlay').removeClass('d-none');
    }

    $('.nav-item.first-level').on('click', function () {
        if (isTouchDevice) {
            $(this).find('.nav-overlay').removeClass('d-none');
        }
    });

    $('.nav-item.first-level').on('mouseleave', function () {
        if (isTouchDevice) {
            $(this).find('.nav-overlay').addClass('d-none');
        }
    });

})(window, document, jQuery);
